import { trackCsEvent } from 'app/client/analytics';
import { getEnvelope } from 'app/client/analytics/utils';

type TriggerLocation = 'post_contact_popup' | 'search_results';
type TriggerObject = 'search_results|alerts_modal' | 'post_contact_popup|alerts_modal';

// https://dataportal.zillowgroup.net/event-registry/5834
export const emitTrackCreateSearchAlertEvent = ({
  triggerLocation,
  triggerObject,
}: {
  triggerLocation: TriggerLocation;
  triggerObject: TriggerObject;
}) => {
  trackCsEvent({
    envelope: getEnvelope({
      eventId: '5834',
      eventVersion: '2',
      templateId: '171',
      templateVersion: '1',
    }),
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: triggerLocation,
      trigger_source_nm: 'button_to_create_search_alert',
      trigger_object_nm: triggerObject,
    },
    semantic: {
      semantic_event_nm: 'create_search_alert',
      topic_tag_txt: [],
    },
  });
};

// https://dataportal.zillowgroup.net/event-registry/5930
export const emitTrackPostContactPopupViewEvent = () => {
  trackCsEvent({
    envelope: getEnvelope({
      eventId: '5930',
      eventVersion: '1',
      templateId: '171',
      templateVersion: '1',
    }),
    clickstream_trigger: {
      trigger_type_nm: 'view',
      trigger_location_nm: 'post_contact_popup',
      trigger_source_nm: 'post_contact_popup',
      trigger_object_nm: 'no_trigger_object',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: [],
    },
  });
};

// https://dataportal.zillowgroup.net/event-registry/5832
export const emitTrackOpenSearchAlertModalEvent = () => {
  trackCsEvent({
    envelope: getEnvelope({
      eventId: '5832',
      eventVersion: '1',
      templateId: '171',
      templateVersion: '1',
    }),
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'search_results',
      trigger_source_nm: 'button_to_open_search_alert_modal',
      trigger_object_nm: 'filter_panel',
    },
    semantic: {
      semantic_event_nm: 'open_search_alert_modal',
      topic_tag_txt: [],
    },
  });
};
